<div class="content-header">Activity</div>
<div class="content-with-elevation content" style="margin-top: 16px;">
  <div class="border-bottom-full-width" *ngIf="!isTldManagerInterface()">
    <div style="display: flex; flex-direction: row;">
        <span *ngFor="let option of options" style="padding: 8px">
        <label>
          <input type="checkbox"
                 name="options"
                 value="{{option.value}}"
                 (change)="changeFilter()"
                 [(ngModel)]="option.checked"/>
          {{option.name}}
        </label>
      </span>
    </div>
  </div>

  <div class="cell large-12 small-12 medium-12" *ngFor="let log of filteredAuditLog">
    <lib-audit-log-individual-section [auditLog]="log" [changeRequestId]="changeRequestVO?.id" [tldName]="changeRequestVO?.tldName"></lib-audit-log-individual-section>
  </div>

</div>
